import baseAPI from './baseAPI'


const getUserProfile = async () => {
    return await baseAPI.get('user/profile')
}

export default {
    getUserProfile,
}